import { ListItem, pxToRem, theme } from '@pocketlaw/tetris';
import styled, { css } from 'styled-components';
const draggingStyles = css `
  &:active:not(:disabled, [disabled]) {
    position: relative;
    z-index: 1;
    box-shadow: ${theme.dropShadow[100]};
    border: ${pxToRem(1)} solid ${theme.semantic.border.default};
    background: ${theme.semantic.surface.primary};
  }
`;
export const ColumnItemContainer = styled(ListItem) `
  margin: 0 ${theme.spacing.sm};
  width: calc(100% - ${theme.spacing.sm} * 2);
  cursor: default;
  ${draggingStyles}
`;
export const HiddenItemContainer = styled(ListItem) `
  margin: 0 ${theme.spacing.sm};
  width: calc(100% - ${theme.spacing.sm} * 2);
`;
